// import logo from './logo.svg';
// import './App.css';
import React from 'react'
import './App.css';
import Reactform from "./Components/Reactform";

function App() {
  return (
    <div className="App">
      <Reactform/>
    </div>
  );
}

export default App;
